import aisp_v162 from "/swagger/aisp_v1-6-2.json?url";
import pisp_v162 from "/swagger/pisp_v1-6-2.json?url";
import oauth2_v171 from "/swagger/oauth2_v1-10-4.json?url";


const SwaggerCatalog = (type:string) => {
    const catalog = [
        {
            title: "Version 1.6.2",
            type: "AISP",
            url: aisp_v162
        },
        {
            title: "Version 1.6.2",
            type: "PISP",
            url: pisp_v162
        },
        {
            title: "Version 1.10.4",
            type: "OAUTH2",
            url: oauth2_v171
        },
    ];

    return catalog.filter(e => e.type === type).map(e => ({label: e.title, value: e.url}))
}

export default SwaggerCatalog;